import React, { useState, useEffect } from "react";
import { ApiHook } from "../../hooks/apiHook";
import { useTranslation } from "react-i18next";
import DatePickerComponent from "../Common/DatePickerComponent";
import Select from "react-select";
import dayjs from "dayjs";
import CrmTable from "./CrmTable";
import LeadEditModal from "../Common/modals/LeadEditModal";
import AddLeadModal from "../Common/modals/AddLeadModal";
import NextFollowUp from "../Common/modals/NextFollowUp";
import SubmitButton from "../Common/buttons/SubmitButton";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import CreateEventsModal from "../Common/modals/CreateEventsModal";
import { Button } from "react-bootstrap";
import { Dropdown } from "react-bootstrap";
import LeadTrackTable from "./LeadTrackTable";
import GoogleLoginModal from "../Common/modals/GoogleLoginModal";
import { toast } from "react-toastify";
import { useQueryClient } from "@tanstack/react-query";

const LeadTracker = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const [apiCheck, setApiCheck] = useState(false);
  const [currentPage, setCurrentPage] = useState({ recent: 1 });
  const [itemsPerPage, setItemsPerPage] = useState({ recent: 10 });

  const [leads, setLeads] = useState();
  const [eventFormData, setEventFormData] = useState({});
  const [googleSignIn, setGooglesignIn] = useState(false);
  const [googleId, setGoogleId] = useState(null);
  const [credentails, setGoogleCredentails] = useState("");
  const [showEventModal, setEventModal] = useState(false);
  const [eventsCheck, setEventsCheck] = useState(false);
  const [leadId, setLeadId] = useState();
  const [stepId, setStepId] = useState();

  //---------------------------------------- API ------------------------------------
  const { data, isLoading } = ApiHook.CallLeadesByStatus();
  const addLeadstatusMutation = ApiHook.AddLeadStatusChange();
  const addLeadEventsMutation = ApiHook.AddLeadEvents();

  const eventsList = ApiHook.GetLeadEventsById(
    eventsCheck,
    setEventsCheck,
    leadId,
    stepId
  );

  useEffect(() => {
    if (data) {
      setLeads(data.groupedByStatus);
    }
  }, [data]);

  const onEvnetsClick = (leadId, stepId) => {
    setLeadId(leadId);
    setStepId(stepId);
    setEventsCheck(true);
  };
  const handleClose = () =>{
    setEventModal(false)
  }

  const onDragEnd = (result) => {
    if (!result.destination) return;
    const { source, destination } = result;
    const sourceCol = leads[source.droppableId];
    const destCol = leads[destination.droppableId];
    const leadStatus = data?.funnalStages.find(
      (obj) => obj.name == destination?.droppableId
    );
    const [movedLead] = sourceCol.splice(source.index, 1);
    destCol.splice(destination.index, 0, movedLead);
    addLeadstatusMutation.mutate(
      { leadStatus: leadStatus?.id, leadId: movedLead?.id },
      {
        onSuccess: (res) => {
          if (res.status) {
            setLeads({ ...leads });
          } else {
            //toast.error(res?.message);
          }
        },
      }
    );
  };

  const setEventModalData = (leadId, stepId) => {
    setEventModal(true);
    const leadAvialbleDetails = data?.funnalStages.find(
      (obj) => obj.id == stepId
    );
    leadAvialbleDetails.leadId = leadId;
    leadAvialbleDetails.leadStatus = stepId;
    console.log(leadAvialbleDetails)

    setEventFormData(leadAvialbleDetails);
  };

  const onSubmit = (data) => {
    // if (!googleId) {
    //   setGooglesignIn(true);
    // } else {
      const updatedEventFormData = {
        ...data,
        googleClintId: googleId,
        code: credentails,
      };
      data.eventDate = dayjs(data?.eventDate).format("YYYY-MM-DD HH:mm:ss");
      addLeadEventsMutation.mutate(
        { eventFormData: updatedEventFormData },
        {
          onSuccess: (res) => {
            if (res.status) {
              setEventModal(false);
              setEventFormData({})
              toast.success("Event added successfully");
              queryClient.invalidateQueries({ queryKey: ["crm-list"] });
            } else {
              setEventModal(false);
              toast.error("Something went wrong");
            }
          },
        }
      );
   //}
  };

  const onSuccess = async (response) => {
    try {
      console.log(response);
      setGoogleId(response?.code);
      setGoogleCredentails(response?.code);
      setGooglesignIn(false);
    } catch (error) {
      console.error("Auth Error:", error);
    }
  };

  const onFailure = (error) => {
    console.error("Login Failed:", error);
  };
  return (
    <div className="row crm-view-lead">
      <div className="col-xl-12">
        <div>
          <div className="crm_panel__h6izZ">
            <LeadTrackTable
              leadList={data?.leadList}
              funnalStages={data?.funnalStages}
              setEventModalData={setEventModalData}
              onEvnetsClick={onEvnetsClick}
              eventsList={eventsList?.data}
              stepId={stepId}
            />
         
          </div>
          <GoogleLoginModal
            googleSignIn={googleSignIn}
            setGooglesignIn={setGooglesignIn}
            onSuccess={onSuccess}
            onFailure={onFailure}
          />

          <CreateEventsModal
            setEventModal={setEventModal}
            showEventModal={showEventModal}
            leadList={data?.leadList}
            funnalStages={data?.funnalStages}
            eventFormData={eventFormData}
            onSubmit={onSubmit}
            handleClose={handleClose}
            
          />
        </div>
      </div>
    </div>
  );
};

export default LeadTracker;
